module.exports = "img/videos/15.2e3ca0.mp4";